import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest, HttpResponse } from '@angular/common/http';
import { Injectable, Injector } from '@angular/core';
import { Observable } from 'rxjs';
import { MatDialog } from '@angular/material/dialog';
import { IFleetSurveyResponseHeader } from '@shared-features/interfaces/fleet-survey-response-header.interface';
import { FleetSurveyDialogComponent } from '@shared-features/components/fleet-survey-dialog/fleet-survey-dialog.component';
import { take, tap } from 'rxjs/operators';
import { UserApi } from '@shared-features/services/user-api.service';
import { UserType } from '@shared-features/enums';

@Injectable()
export class FleetSurveyInterceptor implements HttpInterceptor {
  private static readonly FLEET_SURVEY_HEADER = 'X-Fleet-Survey';
  private dialogOpened = false;
  readonly UserType = UserType;

  constructor(private injector: Injector) {}

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    return next.handle(request).pipe(
      tap((event: HttpEvent<any>) => {
        if (event instanceof HttpResponse) {
          const fleetSurveyResponseHeader = event.headers.get(FleetSurveyInterceptor.FLEET_SURVEY_HEADER);
          if (!fleetSurveyResponseHeader) return;

          try {
            const parsedFleetSurveyResponseHeader: IFleetSurveyResponseHeader = JSON.parse(fleetSurveyResponseHeader);
            const userApi = this.injector.get(UserApi);

            const userType = userApi.currentUser$.value.roles[0]?.userType;

            if (parsedFleetSurveyResponseHeader?.show && !this.dialogOpened && userType === UserType.FLEET) {
              this.dialogOpened = true;
              this.openFleetSurveyDialog(parsedFleetSurveyResponseHeader);
            }
          } catch {}
        }
      })
    );
  }

  private openFleetSurveyDialog(fleetSurveyResponseHeader: IFleetSurveyResponseHeader): void {
    const dialog = this.injector.get(MatDialog);

    dialog
      .open(FleetSurveyDialogComponent, {
        width: '500px',
        disableClose: true,
        data: fleetSurveyResponseHeader,
      })
      .afterClosed()
      .pipe(take(1))
      .subscribe(() => {
        this.dialogOpened = false;
      });
  }
}
